import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { RegulationFilterOptionsFragmentDoc } from '../../../fragments/infinityFilterOptions.generated';
import { MarketNamingTemplateFieldsFragmentDoc } from '../../../fragments/marketNamingTemplateFields.generated';
import { KeywordTagFieldsFragmentDoc } from '../../../fragments/keywordTagFields.generated';
import { AttachmentFieldsFragmentDoc } from '../../../fragments/attachmentFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetVehicleProjectRegulationInfinityQueryVariables = Types.Exact<{
  queryArgAssignedRegulations: Types.QueryArgsAssignedEntityInput;
}>;


export type GetVehicleProjectRegulationInfinityQuery = { __typename?: 'Query', vehicleProjectMasterRegulationsQuery: { __typename?: 'RegulationsInfinityResults', regulationIds: Array<string>, regulationFilterOptions: { __typename?: 'RegulationFilterOptions', regulationOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, marketOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, mainKeywordOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, keywordOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }>, pcmsOptions: Array<{ __typename?: 'FilterOption', name: string, optionKey: string }> }, regulationsBatch: Array<{ __typename?: 'Regulation', id: string, hidden: boolean, regulationNumber: string, name: string, summary: string, createdAt?: any | null, modifiedAt?: any | null, markets: Array<{ __typename?: 'Market', id: string, name: string, regulationNamingTemplates: Array<{ __typename?: 'NamingTemplate', template: string, description: string }>, regulatoryDocumentNamingTemplates: Array<{ __typename?: 'NamingTemplate', template: string, description: string }> }>, mainKeywords: Array<{ __typename?: 'Keyword', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, standardPlusPcmsClusters: Array<{ __typename?: 'StandardPlusPcmsCluster', id: string, name: string }>, createdBy: { __typename?: 'User', id: string, name: string, mail?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', id: string, name: string, mail?: string | null, userPrincipalName?: string | null }, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null }> } };


export const GetVehicleProjectRegulationInfinityDocument = gql`
    query GetVehicleProjectRegulationInfinity($queryArgAssignedRegulations: QueryArgsAssignedEntityInput!) {
  vehicleProjectMasterRegulationsQuery(
    queryArgAssignedRegulations: $queryArgAssignedRegulations
  ) {
    regulationIds
    regulationFilterOptions {
      ...RegulationFilterOptions
    }
    regulationsBatch {
      id
      hidden
      regulationNumber
      name
      summary
      markets {
        id
        name
        ...MarketNamingTemplateFields
      }
      mainKeywords {
        id
        name
      }
      keywords {
        ...KeywordTagFields
      }
      standardPlusPcmsClusters {
        id
        name
      }
      createdAt
      modifiedAt
      createdBy {
        id
        name
        mail
        userPrincipalName
      }
      modifiedBy {
        id
        name
        mail
        userPrincipalName
      }
      attachments {
        ...AttachmentFields
      }
    }
  }
}
    ${RegulationFilterOptionsFragmentDoc}
${MarketNamingTemplateFieldsFragmentDoc}
${KeywordTagFieldsFragmentDoc}
${AttachmentFieldsFragmentDoc}`;

/**
 * __useGetVehicleProjectRegulationInfinityQuery__
 *
 * To run a query within a React component, call `useGetVehicleProjectRegulationInfinityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleProjectRegulationInfinityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleProjectRegulationInfinityQuery({
 *   variables: {
 *      queryArgAssignedRegulations: // value for 'queryArgAssignedRegulations'
 *   },
 * });
 */
export function useGetVehicleProjectRegulationInfinityQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleProjectRegulationInfinityQuery, GetVehicleProjectRegulationInfinityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleProjectRegulationInfinityQuery, GetVehicleProjectRegulationInfinityQueryVariables>(GetVehicleProjectRegulationInfinityDocument, options);
      }
export function useGetVehicleProjectRegulationInfinityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleProjectRegulationInfinityQuery, GetVehicleProjectRegulationInfinityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleProjectRegulationInfinityQuery, GetVehicleProjectRegulationInfinityQueryVariables>(GetVehicleProjectRegulationInfinityDocument, options);
        }
export type GetVehicleProjectRegulationInfinityQueryHookResult = ReturnType<typeof useGetVehicleProjectRegulationInfinityQuery>;
export type GetVehicleProjectRegulationInfinityLazyQueryHookResult = ReturnType<typeof useGetVehicleProjectRegulationInfinityLazyQuery>;
export type GetVehicleProjectRegulationInfinityQueryResult = Apollo.QueryResult<GetVehicleProjectRegulationInfinityQuery, GetVehicleProjectRegulationInfinityQueryVariables>;